module.exports = __webpack_public_path__ + "static/images/price-tag-blue.514166f58d43ba4e9b5d4f336c8e3769.svg";